<rid-syllabic-keyboard-assignments
  class="h-full"
  name="Klankbord plus | regelrecht"
  [layout]="{
    KLINKERS: 'ENABLED',
    LANGE_KLINKERS: 'ENABLED',
    KORTE_LANGE_KLINKERS: 'ENABLED',
    SPACE: 'HIDDEN',
    DUBBELE_KLINKERS: 'ENABLED',
    DRIEDUBBELE_KLINKERS: 'ENABLED',
    VIERDUBBELE_KLINKERS: 'ENABLED',
    MEDEKLINKERS: 'ENABLED',
    EXOTEN: 'HIDDEN',
    SJWAS: 'ENABLED',
    KLANKVOET: 'HIDDEN',
    RULE: 'HIDDEN',
  }"
  [prompts]="prompts()"
  (finished)="finished.emit()"
/>
